import React from 'react';

import PropTypes from 'prop-types';

export const Like = ({ isFilled, className, small }) => {
  const dimensions = small ? 18 : 24;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={dimensions}
      height={dimensions}
      viewBox="0 0 18 17"
      className={className}
    >
      <path
        fill={isFilled ? '#F94A4A' : 'transparent'}
        fillRule="evenodd"
        stroke={isFilled ? '#F94A4A' : 'gray'}
        d="M9.003 15.715a37.765 37.765 0 0 0 3.48-2.618c2.624-2.213 4.393-4.335 4.785-6.114.154-.492.232-1 .232-1.511 0-1.807-.949-3.475-2.472-4.355A4.649 4.649 0 0 0 12.721.5a4.656 4.656 0 0 0-3.36 1.44l-.358.37-.36-.37A4.682 4.682 0 0 0 5.276.5c-.8 0-1.597.213-2.304.617C1.449 1.993.5 3.662.5 5.472c0 .512.078 1.02.242 1.553.356 1.622 1.93 3.59 4.306 5.667a38.97 38.97 0 0 0 2.67 2.126c.546.398.992.706 1.285.897z"
      />
    </svg>
  );
};

Like.propTypes = {
  isFilled: PropTypes.bool,
  small: PropTypes.bool,
  className: PropTypes.string
};

Like.defaultProps = {
  isFilled: false,
  className: null,
  small: false
};

export default Like;
